import { NgFor } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IBreadcrumb } from '../../models/breadcrumb.model';

@Component({
  selector: 'lib-breadcrumb',
  standalone: true,
  imports: [
    NgFor,
    MatIconModule
  ],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {
  list = input.required<IBreadcrumb[]>();
}
